// extracted by mini-css-extract-plugin
module.exports = {"container":"account-password-reset-layout_container__EprFP","inner":"account-password-reset-layout_inner__7o7vY","pageTitle":"account-password-reset-layout_pageTitle__DodDU"};